export const sourceAUM = "aircraftundermaintenances";
export const labelAUM = "Aircraft Under Maintenance";

export const TitlesAUM = {
  list: `${labelAUM} List`,
  edit: `Edit ${labelAUM}`,
  create: `Create ${labelAUM}`,
  detail: `${labelAUM} Detail`,
};

export const ExcelHeader = [
  {
    header: "Maintenance Type",
    key: "Maintenance Type",
    width: 25,
  },
  {
    header: "Scheduled Start date",
    key: "Scheduled Start date",
  },
  {
    header: "Scheduled Finish date",
    key: "Scheduled Finish date",
  },
  {
    header: "Real Start date",
    key: "Real Start date",
  },
  {
    header: "Real Finish date",
    key: "Real Finish date",
  },
  {
    header: "Customer",
    key: "Customer",
  },
  {
    header: "AC",
    key: "AC",
  },
  {
    header: "Remark",
    key: "Remark",
  },
  {
    header: "Created By",
    key: "Created By",
  },
  {
    header: "Created Date",
    key: "Created Date",
  },
  {
    header: "Updated By",
    key: "Updated By",
  },
  {
    header: "Updated Date",
    key: "Updated Date",
  },
];
